import { modifier } from 'ember-modifier';

export default modifier((element: HTMLElement, [isDragging]: [boolean]) => {
  if (isDragging) {
    element.classList.add('droppable');
  } else {
    element.classList.remove('droppable');
  }
});
